<template>
  <div>
    <Button
      tab-index="0"
      aria-pressed="false"
      font-size="11px"
      type="btn-text"
      @keydown.enter="showModal()"
      @keydown.space="showModal()"
      @click="showModal()"
    >
      {{ btnText }}
    </Button>
    <Portal v-if="displayModal" to="modal-container">
      <transition appear name="fade">
        <div role="dialog" aria-modal="true" :aria-labelledBy="btnText">
          <Modal :title="btnText" :separator="true" @close="closeModal()">
            <p v-html="description" />
          </Modal>
        </div>
      </transition>
    </Portal>
  </div>
</template>

<script>
import Vue from 'vue'
import Button from '@sephora-asia/core-button/Button.vue'
import Modal from '@sephora-asia/core-modal/Modal.vue'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)

export default {
  name: 'TermsAndConditions',
  components: {
    Button,
    Modal
  },
  props: {
    /**
     * T&C Policy details
     */
    description: {
      type: String,
      default: ''
    },
    /**
     * Button label as props for translations
     */
    btnText: {
      type: String,
      default: 'Terms & Conditions'
    }
  },
  data() {
    return {
      displayModal: false
    }
  },
  methods: {
    showModal() {
      this.displayModal = true
    },
    closeModal() {
      this.displayModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .btn-text {
  text-decoration: underline;
}
</style>
